//import axios from 'axios'
import { createApp } from 'vue'
import App from './App.vue'
//import sessionStorage from "vue-sessionstorage";
import router from './router'
import store from './store'

//let token = localStorage.getItem('token');
//if (token) axios.defaults.headers.common['Authorization'] = 'Bearer '+token;

createApp(App).use(store).use(router).mount('#app')
